// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MCAs","newExpiryDate":"styles_newExpiryDate__1aUo5","footer":"styles_footer__3XyIp"};